import { CodeSnippetTabs } from './CodeSnippetTabs'
import { ModelDetailSection } from './ModelDetailSection'

const API_BASE_URL = 'https://api.modelstack.cc/v1'

interface ModelDetailCodeExamplesProps {
  modelId: string
}

function buildSnippets(modelId: string) {
  return [
    {
      label: 'Python',
      language: 'python',
      code: `from openai import OpenAI

client = OpenAI(
    api_key="your_api_key",
    base_url="${API_BASE_URL}",
)

response = client.chat.completions.create(
    model="${modelId}",
    messages=[{"role": "user", "content": "Hello!"}],
)
print(response.choices[0].message.content)`,
    },
    {
      label: 'Node.js',
      language: 'javascript',
      code: `import OpenAI from 'openai'

const client = new OpenAI({
  apiKey: 'your_api_key',
  baseURL: '${API_BASE_URL}',
})

const response = await client.chat.completions.create({
  model: '${modelId}',
  messages: [{ role: 'user', content: 'Hello!' }],
})
console.log(response.choices[0].message.content)`,
    },
    {
      label: 'cURL',
      language: 'bash',
      code: `curl ${API_BASE_URL}/chat/completions \\
  -H "Authorization: Bearer your_api_key" \\
  -H "Content-Type: application/json" \\
  -d '{
    "model": "${modelId}",
    "messages": [{"role": "user", "content": "Hello!"}]
  }'`,
    },
  ]
}

export function ModelDetailCodeExamples({ modelId }: ModelDetailCodeExamplesProps) {
  const snippets = buildSnippets(modelId)

  return (
    <ModelDetailSection title="Code examples" note="POST /v1/chat/completions">
      <CodeSnippetTabs snippets={snippets} />
    </ModelDetailSection>
  )
}
